import type { NavItem } from "../types/content";

export const site = {
  name: "Stratify Services",
  shortName: "Stratify",
  description:
    "Book services and event tickets, manage your business, and buy surplus food from local shops with Stratify.",
  email: "support@stratifyservice.com",
  phone: "+974 7099 2884",
  locations: "Doha, Qatar | Abuja, Nigeria",
  appIcon: "/assets/app-icon.png",
  iosUrl: "https://apps.apple.com/us/app/stratify-services-on-demand/id6746335367",
  androidUrl: "https://play.google.com/store/apps/details?id=com.stratifyservice.app",
  youtubeUrl: "https://www.youtube.com/embed/UIeJbsTBT3E",
  socials: [
    { label: "TikTok", href: "https://www.tiktok.com/@stratify.app" },
    { label: "X", href: "https://x.com/stratify_app" },
    { label: "Instagram", href: "https://www.instagram.com/stratify.app" },
  ],
};

export const navItems: NavItem[] = [
  { label: "Home", href: "/#home" },
  { label: "Features", href: "/#features" },
  { label: "Services", href: "/services" },
  { label: "Screenshots", href: "/#screenshots" },
  { label: "Contact", href: "/contact" },
];

export const legalNav = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
  { label: "Community Guidelines", href: "/community-legal" },
  { label: "Data Deletion", href: "/data-deletion" },
];
